import {createSlice, PayloadAction} from "@reduxjs/toolkit";

const initialState = {
  state: {
    top: false,
    left: false,
    bottom: false,
    right: false,
  },
  page : {
    first : false
  }
};


const SideMenuSlice = createSlice({
  name:"sideMenu",
  initialState,
  reducers: {
    changeStatus(state,{payload}: PayloadAction<any>) {
      state.state = payload;
    },
    changeToSecondPage(state,{payload}:PayloadAction<boolean>){
      state.page = {...state,first:payload};
    },
    changeToInitialState(state){
      state.page = {...state.page, first: false};
      state.state = {...state.state,left: false};
    },
  }
});

export const SideMenuActions = SideMenuSlice.actions;

export default SideMenuSlice.reducer;
